// extracted by mini-css-extract-plugin
export default {"navigationMenuList":"navigation-menu-list__navigation-menu-list__q_yhz","shrink":"navigation-menu-list__shrink__ReRxf"};